import {
  Component,
  OnInit,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  FileUploadService,
  FileUploadResponse,
  UploadProgress,
} from '@app/services/file-upload.service';
import { HttpEvent, HttpEventType, HttpResponse } from '@angular/common/http';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styles: [],
})
export class UploadComponent implements OnInit, OnDestroy {
  @Input() file!: File;
  @Input() folder?: string; // Carpeta personalizada para categorizar archivos
  @Output() completed = new EventEmitter<string>();

  percentage: number = 0;
  isUploading: boolean = false;
  isCompleted: boolean = false;
  isError: boolean = false;
  errorMessage: string = '';
  downloadURL: string = '';

  private destroy = new Subject<void>();

  constructor(private fileUploadService: FileUploadService) {}

  ngOnInit(): void {
    this.startUpload();
  }

  startUpload(): void {
    this.isUploading = true;
    this.isError = false;
    this.percentage = 0;

    // Usar carpeta personalizada si se proporciona, sino usar 'faq' como categoría por defecto
    const category = this.folder || 'faq';

    this.fileUploadService
      .uploadFileWithProgress(this.file, category)
      .pipe(takeUntil(this.destroy))
      .subscribe({
        next: (event) => {
          if (this.isUploadProgress(event)) {
            // Actualizar progreso
            this.percentage = event.progress;
          } else if (this.isHttpResponse(event)) {
            // Upload completado
            this.isUploading = false;
            this.isCompleted = true;
            this.downloadURL = event.body?.fileUrl || '';
            this.completed.emit(this.downloadURL);
          }
        },
        error: (error) => {
          console.error('Error al subir archivo:', error);
          this.isUploading = false;
          this.isError = true;
          this.errorMessage = error.message || 'Error al subir el archivo';
        },
      });
  }

  private isUploadProgress(event: any): event is UploadProgress {
    return event && typeof event.progress === 'number';
  }

  private isHttpResponse(
    event: any
  ): event is HttpResponse<FileUploadResponse> {
    return event && event.type === HttpEventType.Response;
  }

  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }
}
